module.exports = __webpack_public_path__ + "static/top-bg-8ac552a5d10d6bf0d721f40e36a532f0.png";